import {
  ADICIONAR_FILTRO_PEDIDO,
  LIMPAR_FILTRO_PEDIDO, LISTAR_FILTROS_PEDIDOS,
  REMOVER_FILTRO_PEDIDO
} from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initialState = undefined

const initial = {
}

export const filtrosAdicionadosPedido = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_PEDIDO: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_PEDIDO: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    case LIMPAR_FILTRO_PEDIDO: {
      return []
    }

    default:
      return state
  }
}

export const filtrosPedidos = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_PEDIDOS: {
      const retorno = action.payload.data;
      if(retorno){
        return retorno
      }
      return initialState
    }
    default:
      return state
  }
}
